
import "../Foundation/stylable/colors.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_182_0_SkeletonGroup";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_182_0_SkeletonGroup__root","animator":"wds_1_182_0_SkeletonGroup__animator"};
export var keyframes = {"wave":"wds_1_182_0_SkeletonGroup__wave"}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"color":"--wds_1_182_0_SkeletonGroup-color"}; 




